import { useState, useEffect } from 'react';
import { Typography } from '@mui/material';
import { format } from 'date-fns';

export const LiveClock = () => {
    const [time, setTime] = useState(new Date());

    useEffect(() => {
        const interval = setInterval(() => setTime(new Date()), 1000);
        return () => clearInterval(interval);
    }, []);

    return (
        <Typography variant="h5" sx={{ fontFamily: 'monospace', letterSpacing: 3, color: 'text.primary' }}>
            {format(time, 'HH:mm:ss')}
        </Typography>
    );
};
